
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { assertIsFn, AddContext } from "@storybook/addon-docs";

import { ArgsTable, Canvas, Meta, Story } from '@storybook/addon-docs';
import baseDemo from './demo/base.twig';
import codeTableDemo from './demo/code-table.twig';
const argTypes = {
  class: {
    type: 'string',
    description: 'CSS class(es) to append to the root element.',
  },
  wrapLines: {
    type: 'boolean',
    description: 'Allow lines to wrap',
  },
};


const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Meta title="Vendor/Syntax-Highlighting Code Block" argTypes={argTypes} parameters={{
      docs: {
        transformSource: src => src
      },
      layout: 'fullscreen'
    }} decorators={[story => {
      const result = story();
      if (result.includes('wp-block-code')) {
        return `<div class="o-container o-container--pad o-container--prose"><div class="o-container__content">${result}</div></div>`;
      }
      return result;
    }]} mdxType="Meta" />
    <h1>{`Syntax-Highlighting Code Block`}</h1>
    <p>{`The `}<a parentName="p" {...{
        "href": "https://wordpress.org/plugins/syntax-highlighting-code-block/"
      }}>{`Syntax-Highlighting Code Block`}</a>{` is a plugin for WordPress that enhances the native code block with some additional functions. It uses `}<a parentName="p" {...{
        "href": "https://github.com/scrivo/highlight.php"
      }}>{`highlight.php`}</a>{` to apply syntax highlighting on the server instead of the client.`}</p>
    <p>{`This leverages the same styles `}<a parentName="p" {...{
        "href": "/?path=/docs/vendor-highlight--theme"
      }}>{`as our Highlight.js theme`}</a>{`. But as of this writing, `}<a parentName="p" {...{
        "href": "https://github.com/scrivo/highlight.php/issues/73"
      }}>{`Highlight.php is two major versions behind Highlight.js`}</a>{`. As a result, syntax highlighting may differ between platforms.`}</p>
    <h2>{`Basic Output`}</h2>
    <p>{`Without any options selected, the plugin applies highlighting and appends a description of the code language for assistive devices (hidden visually).`}</p>
    <Canvas mdxType="Canvas">
  <Story name="Basic" mdxType="Story">{args => baseDemo(args)}</Story>
    </Canvas>
    <ArgsTable story="Basic" mdxType="ArgsTable" />
    <h2>{`More Features`}</h2>
    <p>{`The plugin also supports line wrapping, highlighted lines and line numbering. Our theme requires `}<a parentName="p" {...{
        "href": "https://github.com/westonruter/syntax-highlighting-code-block/wiki#suppress-all-plugin-styles"
      }}>{`default plugin styles to be suppressed`}</a>{` so it won't conflict with these styles.`}</p>
    <Canvas mdxType="Canvas">
  <Story name="More Features" argTypes={{
        ...argTypes,
        lineNumbers: {
          type: 'boolean',
          description: 'Show numbers per line'
        }
      }} args={{
        lineNumbers: true,
        wrapLines: true
      }} mdxType="Story">
    {args => codeTableDemo(args)}
  </Story>
    </Canvas>
    <ArgsTable story="More Features" mdxType="ArgsTable" />
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

export const basic = (args => baseDemo(args));
basic.storyName = 'Basic';
basic.parameters = { storySource: { source: 'args => baseDemo(args)' } };

export const moreFeatures = (args => codeTableDemo(args));
moreFeatures.storyName = 'More Features';
moreFeatures.argTypes = {
  ...argTypes,
  lineNumbers: {
    type: 'boolean',
    description: 'Show numbers per line'
  }
};
moreFeatures.args = {
  lineNumbers: true,
  wrapLines: true
};
moreFeatures.parameters = { storySource: { source: 'args => codeTableDemo(args)' } };

const componentMeta = { title: 'Vendor/Syntax-Highlighting Code Block', parameters: {
  docs: {
    transformSource: src => src
  },
  layout: 'fullscreen'
}, decorators: [story => {
  const result = story();
  if (result.includes('wp-block-code')) {
    return `<div class="o-container o-container--pad o-container--prose"><div class="o-container__content">${result}</div></div>`;
  }
  return result;
}], argTypes: argTypes, includeStories: ["basic","moreFeatures"],  };

const mdxStoryNameToKey = {"Basic":"basic","More Features":"moreFeatures"};

componentMeta.parameters = componentMeta.parameters || {};
componentMeta.parameters.docs = {
  ...(componentMeta.parameters.docs || {}),
  page: () => <AddContext mdxStoryNameToKey={mdxStoryNameToKey} mdxComponentAnnotations={componentMeta}><MDXContent /></AddContext>,
};

export default componentMeta;